import React from 'react';
import { Form, Button, Space } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import FormItem from '../FormItem';

interface DynamicFormListProps {
  name: string;
  label?: string;
  itemConfig: any; // 子表单项的配置
  addButtonText?: string;
  minItems?: number;
  maxItems?: number;
  initialValue?: any[];
}

const DynamicFormList: React.FC<DynamicFormListProps> = ({
  name,
  label,
  itemConfig,
  addButtonText = '添加项目',
  minItems = 0,
  maxItems = 10,
  initialValue = []
}) => {
  return (
    <Form.List name={name} initialValue={initialValue}>
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name: fieldName, ...restField }) => (
            <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
              {/* 渲染子表单项 */}
              {Array.isArray(itemConfig) ? (
                // 如果是多个字段的配置
                itemConfig.map((config, index) => (
                  <FormItem
                    key={`${fieldName}-${index}`}
                    item={{
                      ...config,
                      key: [fieldName, config.key],
                      name: [fieldName, config.key],
                      ...restField,
                    }}
                    index={`${fieldName}-${index}`}
                  />
                ))
              ) : (
                // 如果是单个字段的配置
                <FormItem
                  item={{
                    ...itemConfig,
                    key: fieldName,
                    name: fieldName,
                    ...restField,
                  }}
                  index={fieldName}
                />
              )}
              
              {/* 删除按钮 */}
              {fields.length > minItems && (
                <MinusCircleOutlined
                  className="dynamic-delete-button"
                  onClick={() => remove(fieldName)}
                  style={{ color: '#ff4d4f' }}
                />
              )}
            </Space>
          ))}
          
          {/* 添加按钮 */}
          {fields.length < maxItems && (
            <Form.Item>
              <Button
                type="dashed"
                onClick={() => add()}
                block
                icon={<PlusOutlined />}
              >
                {addButtonText}
              </Button>
            </Form.Item>
          )}
        </>
      )}
    </Form.List>
  );
};

export default DynamicFormList;
